import { api } from '@/api'
import { dataStates } from '@garpix/fetcher'
import Button from '@/components/Button'
import { Select, SelectItem } from '@/components/Select'
import BlockSpinner from '@/components/Spinner/BlockSpinner'
import Spinner from '@/components/Spinner/Spinner'
// import { certificate } from '@/images'
import { IChampionship } from '@/interfaces/Championship'
import React, { useEffect, useState } from 'react'
import PlaceBlock from './components/PlaceBlock'
import style from './styles/cabinet_certificate.module.scss'
import { useCurrentUser } from '@/hooks'
import NoSearchResults from '@/components/NoSearchResults'

const CabinetCertificates = (): React.ReactElement => {
  const { currentUser } = useCurrentUser()
  const [generating] = useState(false)
  const [championships, setChampionships] = useState<IChampionship[]>([])
  const [status, setStatus] = useState(dataStates.notAsked)
  const [version, setVersion] = useState('')
  const [championship, setChampionship] = useState<IChampionship | undefined>()
  const [result, setResult] = useState<string | undefined>(undefined)
  // const [generating, setGenerating] = useState(false)

  useEffect(() => {
    if (version === '') {
      setChampionships([])
    } else {
      setStatus(dataStates.loading)
      api
        .getUserChampionships({ version, status: '' })
        .then((data) => {
          setStatus(dataStates.loaded)
          setChampionships(data.results)
        })
        .catch((error) => {
          console.log(error, 'error')
        })
    }
  }, [version])

  const scores = championship?.scores ?? []
  const place = scores?.[scores.length - 1]?.place ?? undefined

  const handleVersion = (e): void => {
    setVersion(e.target.value)
    setChampionship(undefined)
  }

  const handleChampionship = (e): void => {
    const id = Number(e.target.value)
    const obj = championships.find((item) => Number(item.id) === id)
    setChampionship(obj)
  }

  const handleCertificate = (): void => {
    api
      .makeCertificate({
        name: `${currentUser.name} ${currentUser.last_name}`,
        place: place ?? '',
        description: championship?.name ?? ''
      })
      .then((data) => {
        setResult(data)
      })
      .catch((error) => {
        console.log(error)
      })
  }

  return (
    <div className={style.cert}>
      <div className={style.cert_left}>
        <Select
          onGx-change={handleVersion}
          placeholder='Выбери игру'
          label='Игра:'
          required
          className={style.cert_block}
        >
          <SelectItem value='1'>Жэка “Квартира”</SelectItem>
          <SelectItem value='2'>Жэка “Дом”</SelectItem>
          <SelectItem value='3'>Жэка “Квартал”</SelectItem>
          <SelectItem value='4'>Жэка “Чистый город”</SelectItem>
          <SelectItem value='5'>Жэка “Урбанистика”</SelectItem>
        </Select>
        {status === dataStates.loading ? <BlockSpinner /> : null}
        {championships.length > 0 && status === dataStates.loaded
          ? (
            <Select
              onGx-change={handleChampionship}
              label='Чемпионат:'
              placeholder='Выбери чемпионат'
              required
              className={style.cert_block}
            >
              {championships.map((championship) => {
                return (
                  <SelectItem key={championship.id} value={championship.id}>
                    {championship.name}
                  </SelectItem>
                )
              })}
            </Select>
            )
          : null}
        {championships.length === 0 && status === dataStates.loaded
          ? (
            <NoSearchResults text='К сожалению, не удалось найти чемпионаты по этой игре' />
            )
          : null}
        {place !== undefined ? <PlaceBlock place={place} /> : null}
        {place === undefined && championship !== undefined
          ? (
              'Мы считает очки в этом турнире, попробуйсте позже! Спасибо'
            )
          : (
            <Button
              onClick={handleCertificate}
              highlight
              disabled={championship === undefined}
              wide
            >
              {generating ? <Spinner /> : 'Сгенерировать'}
            </Button>
            )}
      </div>
      {result !== undefined
        ? (
          <div className={style.cert_right}>
            <img
              src={result}
              width='400px'
              height='535px'
              alt='Сертификат'
              className={style.cert__image}
            />

            <Button href={result} download='result.png' wide theme='secondary'>
              Скачать
            </Button>
          </div>
          )
        : null}
    </div>
  )
}

export default CabinetCertificates
